let fs = null;
if (process.env.IS_ELECTRON) {
  fs = require("fs");
} else {
  fs = {};
}
// import fs from "fs";
// export default {};
export default fs;
